import React, { Fragment, useEffect } from "react";
import SEO from "../../components/SEO/SEO";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import AboutSection from "../../components/about/about";
import FeatureSection from "../../components/FeatureSection/FeatureSection";
import TeamSection from "../../components/TeamSection/TeamSection";
import AwardSection from "../../components/AboutComponents/AwardSection/AwardSection";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";

const AboutPage: React.FC = () => {
  return (
    <Fragment>
      <SEO title="About AXOIX" description="Learn about AXOIX — the AI-powered business operating system by Axoix Technologies Private Limited. Our mission, vision, and the team behind 22 AI characters serving 19 industries." path="/about" />
      <div className="about-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle="About AXOIX" pagesub="About Us" />
            <AboutSection />
            <FeatureSection />
            <TeamSection />
            {/* <AwardSection /> */}
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default AboutPage;
